import http from "@/services/http";

// Área administrativa da plataforma (somente super admin)
export const admin = () => {
  async function list(params = {}) {
    const {data} = await http.get('/admin/tenants', { params });
    return data;
  }

  async function getOne(id) {
    const {data} = await http.get('/admin/tenants/'+id);
    return data;
  }

  async function payments(params = {}) {
    const {data} = await http.get('/admin/payments', { params });
    return data;
  }

  async function resetPassword(id_user, password) {
    const {data} = await http.post('/admin/users/password', { id_user, password });
    return data;
  }

  async function impersonate(id_user) {
    const {data} = await http.post('/admin/users/impersonate', { id_user });
    return data;
  }

  return {list, getOne, payments, resetPassword, impersonate};
}
